/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import IErrorParams from '../../Server/Error/IErrorParams';
import StateDependencyComponent from '../../StateManager/StateDependencyComponent';
import StateEvent from '../../StateManager/StateEvent';
import { StateID } from '../../StateManager/StateID';
import StateReference from '../../StateManager/StateReference';
import { ReferenceGroup } from '../../Utility/Component/ComponentReference/ReferenceGroup';
import { IPopupOptions } from '../../Utility/Component/Popup/IPopupModal';
import DefaultAdapter from './DefaultAdapter';
import IPlatformAdapter from './IPlatformAdapter';
import NyxAdapter from './NyxAdapter';
import { INyxWindow } from './NyxInterfaces';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class ClientEvents extends StateDependencyComponent
{
    /** The state on which ClientEvents should send game ready message. */
    @property({ type: StateReference, visible: true })
    protected _gameReadyState: StateReference = new StateReference(StateID.PostInitializing);

    /**
     * TODO : Refactor into two groups, actual wager attempt and
     * spin starting (i.e. for bonus spins w/ no wager being made).
     */
    /** The state on which ClientEvents should send attempting wager event. */
    @property({ type: [StateReference], visible: true })
    protected _requestAttemptStates: StateReference[] = [
        new StateReference(StateID.Request, false, ReferenceGroup.MainGame),
        new StateReference(StateID.Request, false, ReferenceGroup.BonusGame_0)
    ];

    /** The state on which ClientEvents should send wager made event. */
    @property({ type: [StateReference], visible: true })
    protected _requestMadeStates: StateReference[] = [
        new StateReference(StateID.Spinning, false, ReferenceGroup.MainGame),
        new StateReference(StateID.Spinning, false, ReferenceGroup.BonusGame_0)
    ];

    /** The state on which ClientEvents should send result displayed event. */
    @property({ type: [StateReference], visible: true })
    protected _resultDisplayedStates: StateReference[] = [
        new StateReference(StateID.PostPlay, true, ReferenceGroup.MainGame),
        new StateReference(StateID.Initializing, true, ReferenceGroup.BonusGame_0),
        new StateReference(StateID.Bonus, true, ReferenceGroup.BonusGame_0)
    ];

    private _adapter: IPlatformAdapter = null;

    /** @hidden */
    protected start(): void
    {
        super.start(
            this._gameReadyState,
            this._requestAttemptStates,
            this._requestMadeStates,
            this._resultDisplayedStates
        );

        if (CC_JSB)
        {
            this.node.destroy();
        }
        else if (((window as any) as INyxWindow)._gcmDelegate)
        {
            this._adapter = new NyxAdapter();
        }
        else
        {
            this._adapter = new DefaultAdapter();
        }
    }

    /** @hidden */
    protected onStateChangeHandler = (event: StateEvent): void =>
    {
        if (this._gameReadyState.Value === event.State)
        {
            this._adapter.GameLoaded();
        }

        if (this._requestMadeStates.some((x) => x.Value === event.State))
        {
            this._adapter.WagerMade(event.State);
        }

        if (this._requestAttemptStates.some((x) => x.Value === event.State))
        {
            this._adapter.WagerRequested(event.State);
        }

        if (this._resultDisplayedStates.some((x) => x.Value === event.State))
        {
            if (!this._adapter.ResultDisplayed(this, event.State))
            {
                this.completeState(event.State);
            }
        }
    }

    public GameLoaded(): void
    {
        this._adapter.GameLoaded();
    }

    public ReportError(errorCode: string, errorParams: IErrorParams, popupOptions?: IPopupOptions): void
    {
        this._adapter.ReportError(errorCode, errorParams, popupOptions);
    }

    public WalletNotification(notification: any): void
    {
        this._adapter.WalletNotification(notification);
    }
}
